import { createSlice } from "@reduxjs/toolkit";
import i18next from "i18next";
import jalaali from "jalaali-js"; // Import jalaali-js for date conversion

const getInitialName = () => {
  const label = i18next.language === "en" ? "FileName_" : "نام سند_";
  return `${label}${getFormattedJalaliDate()}`;
};
const getFormattedJalaliDate = () => {
  const today = new Date(); // Get the current date
  const jalaliDate = jalaali.toJalaali(
    today.getFullYear(),
    today.getMonth() + 1,
    today.getDate()
  );
  const hours = String(today.getHours()).padStart(2, "0"); // Ensure hours are two digits
  const minutes = String(today.getMinutes()).padStart(2, "0");
  const year = jalaliDate.jy;
  const month = String(jalaliDate.jm).padStart(2, "0"); // Ensure month is two digits
  const day = String(jalaliDate.jd).padStart(2, "0"); // Ensure day is two digits

  return `${year}${month}${day}${hours}${minutes}`;
};
export const printType = [{ type: "1" }, { type: "2" }];
export const printStatus = [{ status: "1" }, { status: "2" }];
export const printTime = [
  { time: "1" },
  { time: "6" },
  { time: "12" },
  { time: "24" },
];
export const isFitPage = [{ isFitPage: true }, { isFitPage: false }];
export const status = [{ status: "1" }, { status: "2" }];

export const paperSize = [
  {
    size: "A4",
  },
  {
    size: "A3",
  },
  {
    size: "A5",
  },
];
export const orientartion = [
  {
    orientartion: 1,
  },
  {
    orientartion: 2,
  },
];
const initialState = {
  step: 0,
  formData: {
    name: getInitialName(),
    size: "A4",
    type: "1",
    status: "1",
    orientartion: 2,
    isFitPage: true,
    time: "1",
    price: 0,
    page: 0,
    totalPages: 0, // Add totalPages to track PDF pages
  },
  forgotPass: 0,
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    nextStep: (state) => {
      state.step += 1;
    },
    prevStep: (state) => {
      state.step -= 1;
    },
    resetForm: (state) => {
      state.step = 0;
      state.formData = initialState.formData;
    },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    updatePrice: (state, action) => {
      state.formData.price = action.payload;
    },
    updatePage: (state, action) => {
      state.formData.page = action.payload;
    },
    updateTotalPages: (state, action) => {
      state.formData.totalPages = action.payload;
    },
  },
});

export const {
  resetForm,
  updateFormData,
  nextStep,
  prevStep,
  updatePrice,
  updatePage,
  updateTotalPages,
} = formSlice.actions;
export default formSlice.reducer;
